/** @jsx jsx */
import { jsx, useColorMode } from "theme-ui"
import { Fragment, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Global } from "@emotion/core"
import VisuallyHidden from "@reach/visually-hidden"
import Master from "react-div-100vh"
import SEO from "../components/seo"
import Footer from "../components/footer"
import MessageSender from "../components/message-sender"

const AnimatedSun = () => {
  return (
    <motion.div
      initial={{ scale: 30 }}
      animate={{ scale: 1 }}
      exit={{ scale: 30 }}
      sx={{
        zIndex: 3,
        position: "relative",
      }}
    >
      <motion.div
        animate={{ scale: [1, 2.3] }}
        transition={{
          yoyo: Infinity,
          ease: "easeInOut",
          duration: 0.12,
        }}
        sx={{
          width: "83px",
          height: "83px",
          borderRadius: "50%",
          bg: t => t.colors.background,
          boxShadow: t => `0 0 2em 0 ${t.colors.primary}`,
        }}
      />
    </motion.div>
  )
}

const HomePage = () => {
  const [playing, setPlaying] = useState(false)
  const [colorMode, setColorMode] = useColorMode()
  const [originalColorMode] = useState(colorMode)

  return (
    <Fragment>
      <SEO />
      <Master
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <div
          role="button"
          tabIndex={0}
          onMouseEnter={() => setPlaying(true)}
          onMouseLeave={() => {
            setPlaying(false)
            setColorMode(originalColorMode)
          }}
          onTouchStart={() => {
            setPlaying(!playing)
            playing && setColorMode(originalColorMode)
          }}
          sx={{
            borderRadius: "50%",
            position: "absolute",
            zIndex: 4,
            width: "250px",
            height: "250px",
            cursor: "none",
            ":focus": {
              outline: 0,
            },
          }}
        >
          <VisuallyHidden>
            This app works best with JavaScript enabled but if you can't do that
            here a little bit about us. We create digital products, services and
            campaigns. Producing the highest possible user experience for your
            business and target audience. Our creative thinking and innovation
            enables us to solve complex problems and provide effective global
            digital solutions. This button will create an entire new visual
            experience that websites can provide but digital agencies don't use.
            Unfortunately, we are incapable to translate this to a non visual
            form at the moment. But the message that we are spreading is simple.
            Good websites doesn`t come by simply designing a template-like
            website once a year and not worrying about the customer. This is a
            progression work. The only way to win it is to slowly moving forward
            and remember from where you came from. Simple but not easy to
            understand. We hope our visual fellows stop ignoring you some day
            and make you feel home in this beauty that is the internet.
          </VisuallyHidden>
        </div>

        {playing && (
          <Fragment>
            <Global
              styles={{
                "#hubspot-messages-iframe-container": {
                  opacity: 0,
                },
              }}
            />
            <MessageSender>
              | | THIS WHOLE THING IS DEEP. | IT TAKES TIME TO UNDERSTAND THAT.
              | READ CAREFULLY | | PERCEPTION PERCEPTION PERCEPTION CREATES
              CREATES CREATES REALITY. REALITY. REALITY. | | | THIS GAME IS NOT
              ABOUT A BORING ABOUT-US-PAGE ABOUT-US-PAGE ABOUT-US-PAGE | A
              RANDOM IMAGE | OR A STOCK VIDEO. | | YOU HAVE TO CHANGE THEIR
              PERCEPTION WHERE THEY DON&apos;T EXPECT. | | TOUCHING WHERE NO ONE
              ELSE TOUCHES. | WE DO WHAT THE DIGITAL AGENCIES SHOULD BE DOING. |
              WE WE CHANGE CHANGE PERCEPTION. PERCEPTION. | | THIS IS THE MAZE
              MAZE MAZE MAZE MAZE MAZE MAZE
            </MessageSender>
          </Fragment>
        )}
        <AnimatePresence>
          {!playing && (
            <Fragment>
              <AnimatedSun />

              <div
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  zIndex: 2,
                  p: 3,
                }}
              >
                <Footer />
              </div>
            </Fragment>
          )}
        </AnimatePresence>
      </Master>
    </Fragment>
  )
}

export default HomePage
